// extracted by mini-css-extract-plugin
export default {"WeekForecast":"styles_WeekForecast__mXmfj","heading":"styles_heading__j+Kma","itemsWrapper":"styles_itemsWrapper__I44+n"};